import Icon from 'veui/components/Icon'
import { IconMediumSquare } from 'dls-icons-vue'

Icon.register('medium-square', IconMediumSquare)
